











































































import { Component, Mixins } from 'vue-property-decorator';
import { LinkIdentity } from '~/mixins';
import LinkedAccountCard from '~/components/UIComponents/LinkedAccountCard.vue';
import TwoFactorAuthInputPrompt from '~/components/ModalPrompts/TwoFactorAuthInputPrompt.vue';

@Component({
  components: { TwoFactorAuthInputPrompt, LinkedAccountCard },
})
export default class SocialLogins extends Mixins(LinkIdentity) {
  showPasswordSetupPrompt = false;
  socialOptions = [
    {
      icon: 'https://static.gala.games/images/logos/social/google_icon.png',
      name: 'Google',
      connection: 'google-oauth2',
    },
    {
      icon: 'https://static.gala.games/images/logos/social/apple_icon.png',
      name: 'Apple',
      connection: 'apple',
    },
    {
      icon:
        'https://static.gala.games/images/logos/social/facebook_icon_royal_blue.png',
      name: 'Facebook',
      connection: 'facebook',
    },
  ];

  get formattedSocials() {
    return this.socialOptions.map(social => {
      const connectedSocial = this.auth0UserIdentities.find(
        i => i.connection === social.connection,
      );
      const fullEmail = connectedSocial?.email ?? '';
      const truncatedEmail = this.truncateEmailAddress(
        fullEmail,
        this.$vuetify.breakpoint.width,
      );
      return {
        ...social,
        email: fullEmail,
        truncatedEmail,
        connected: !!connectedSocial,
        uid: connectedSocial?.user_id,
      };
    });
  }

  get socialProviderConnecting() {
    return this.requestInFlight ? this.selectedSocialProvider : '';
  }

  async created() {
    this.checkQueryParams();
  }

  truncateEmailAddress(address: string, screenWidth: number) {
    let maxCharCount = this.$vuetify.breakpoint.mdAndDown ? 12 : 18;

    switch (true) {
      case screenWidth < 410:
        maxCharCount = 10;
        break;
      case screenWidth < 490:
        maxCharCount = 16;
        break;
      case screenWidth < 600:
        maxCharCount = 20;
        break;
      case screenWidth < 960:
        maxCharCount = 16;
        break;
      case screenWidth < 1100:
        maxCharCount = 8;
        break;
      case screenWidth < 1264:
        maxCharCount = 16;
        break;
      case screenWidth < 1500:
        maxCharCount = 30;
        break;
      default:
        maxCharCount = 50;
    }

    if (address.length <= maxCharCount) {
      return address;
    }

    const string = `${address.slice(0, maxCharCount)}...`;

    return string;
  }

  handleDisconnectClick(provider: string, secondaryUserId: string) {
    const primaryIdentity = this.auth0UserIdentities[0];
    if (primaryIdentity?.provider === provider) {
      this.showPasswordSetupPrompt = true;
      return;
    }

    this.handleDisconnect(provider, secondaryUserId);
  }

  goToPasswordSetup() {
    this.showPasswordSetupPrompt = false;
    this.$router.push('/account?component=ResetAccountPassword');
  }
}
